import { useRouteMatch } from '@speedlo/hooks'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useRoot } from '../../app/useRoot'
import {
  useQShopHeaderBranch,
  useQShopHeaderIntro,
} from '../../graph/generated'
import { useOrderOriginUrl } from '../../hooks/useOrderOriginUrl'
import { ShopHeader } from './ShopHeader'

export const ShopHeaderView = observer(() => {
  const { order, business } = useRoot()
  const orderOrigin = useOrderOriginUrl()
  const homeMatch = useRouteMatch('/')

  const isOnHomePage = homeMatch?.isExact || false
  const cameFromPortal = orderOrigin === 'portal'
  const highlightSpeedlo = isOnHomePage && cameFromPortal

  const { data: dataIntro } = useQShopHeaderIntro(
    {
      brandId:
        business.isBrand && !order.hasOrder ? business.brandId : undefined,
      // need to use branchId from order first as it reflects branch for which
      // order is being made and it might have different eg. business hours
      // then the one obtained through business code
      branchId:
        business.isBrand && !order.hasOrder
          ? undefined
          : order.branchId || business.branchId!,
    },
    {
      skip: !business.isValid,
      fetchPolicy: 'cache-first',
    },
  )

  const { data: dataBranch } = useQShopHeaderBranch(
    {
      branchId: order.branchId!,
    },
    {
      skip: !order.branchId,
      fetchPolicy: 'cache-first',
    },
  )

  return (
    <ShopHeader
      branch={dataBranch ? dataBranch.branch : null}
      intro={dataIntro ? dataIntro.intro : null}
      highlightSpeedlo={highlightSpeedlo}
    />
  )
})

export default ShopHeaderView
